import { RouteRecordRaw } from "vue-router";

import { ROLES_AND_PERMISSION_ON_ROUTES } from "@/core/configs/rolesAndPermissionsMappingOnRoutes";
import { PATH } from "@/core/constants/path";

const routes: Array<RouteRecordRaw> = [
  {
    path: PATH.ADD_VISA_VERIFICATION_REQ,
    name: "visaVerificationForm",
    meta: {
      roles: ROLES_AND_PERMISSION_ON_ROUTES.VISA_VERIFICATION.ROLES,
      permissions: ROLES_AND_PERMISSION_ON_ROUTES.VISA_VERIFICATION.PERMISSIONS,
    },
    component: () =>
      import("@/modules/VisaVerification/views/AddInformationForm.vue"),
  },
  {
    path: PATH.VISA_VERIFICATION,
    name: "visaVerificationList",
    meta: {
      roles: ROLES_AND_PERMISSION_ON_ROUTES.VISA_VERIFICATION.ROLES,
      permissions: ROLES_AND_PERMISSION_ON_ROUTES.VISA_VERIFICATION.PERMISSIONS,
    },
    component: () => import("@/modules/VisaVerification/views/List.vue"),
  },
];

export default routes;
